export class CsvMappingDefinitionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCsvMappingDefinitionList(params) {
    return this.#http.get('/CsvMappingDefinition/list', { params });
  }

  async createCsvMappingDefinition(body) {
    return this.#http.post('/CsvMappingDefinition', body);
  }

  async editCsvMappingDefinition({ csvMappingDefinitionId, ...body }) {
    return this.#http.put(`/CsvMappingDefinition/${csvMappingDefinitionId}`, body);
  }

  async deleteCsvMappingDefinition({ csvMappingDefinitionId }) {
    return this.#http.delete(`/CsvMappingDefinition/${csvMappingDefinitionId}`);
  }
}
